module.exports = __webpack_public_path__ + "img/handraw_ancre_marron.3946faa8.svg";